type ValueSource = string | string[] | undefined

export const getValueFromHeader = (value: ValueSource): string | undefined => {
  if (!value) return undefined

  if (Array.isArray(value)) {
    return value[0]
  }

  return value
}